export const REQUEST_LOG_SELECTED_ROW_BACKGROUND = "rgb(239 246 255)";
export const REQUEST_LOG_RECENTLY_VIEWED_ROW_BACKGROUND = "rgb(248 250 252)";
export const REQUEST_LOG_GRID_HOVER_STYLE = [
  ".pl-request-logs-grid { -webkit-text-size-adjust: 100%; text-size-adjust: 100%; }",
  ".pl-request-logs-grid .ag-root-wrapper, .pl-request-logs-grid .ag-cell, .pl-request-logs-grid .ag-header-cell, .pl-request-logs-grid .ag-header-cell-text, .pl-request-logs-grid .ag-paging-panel { -webkit-text-size-adjust: 100%; text-size-adjust: 100%; }",
  ".pl-request-logs-grid .ag-cell, .pl-request-logs-grid .ag-paging-panel { font-size: 14px; }",
  ".pl-request-logs-grid .ag-header-cell, .pl-request-logs-grid .ag-header-cell-text { font-size: 13px; }",
  ".pl-request-logs-grid .ag-row-hover .ag-cell { background-color: rgb(239 246 255 / 0.5) !important; }",
  ".pl-request-logs-grid .ag-center-cols-container .ag-row-hover::before { content: ''; pointer-events: none; position: absolute; top: 8px; bottom: 8px; left: 0; z-index: 10; width: 2px; border-radius: 9999px; background-color: rgb(96 165 250); box-shadow: 0 0 8px rgba(59, 130, 246, 0.55); }",
].join(" ");

export const requestLogSidebarActiveRailClass =
  "overflow-hidden before:pointer-events-none before:absolute before:inset-y-2 before:left-0 before:z-10 before:w-0.5 before:rounded-full before:bg-blue-500 before:shadow-[0_0_8px_rgba(59,130,246,0.65)] before:transition-[box-shadow,opacity] before:duration-200 before:ease-out";

export const requestLogSidebarInactiveHoverRailClass = [
  "overflow-hidden",
  "before:pointer-events-none before:absolute before:inset-y-2 before:left-0 before:z-10 before:w-0.5 before:rounded-full before:bg-blue-400",
  "before:opacity-0 before:shadow-[0_0_8px_rgba(59,130,246,0.55)] before:transition-[box-shadow,opacity] before:duration-200 before:ease-out",
  "hover:before:opacity-100",
].join(" ");

export const requestLogGridSurfaceClassName = [
  "[&_.ag-row]:transition-colors [&_.ag-row]:duration-150",
  "[&_.ag-header]:border-b [&_.ag-header]:border-[var(--ag-border-color)]",
  "[&_.ag-root-wrapper]:overflow-hidden",
].join(" ");
